import { render } from "./notfound.vue?vue&type=template&id=15c0f8b1"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__